'use client';

import { useEffect } from 'react';
import { logPageViewEvent, type ContentTrackingMeta } from '@/utils/tracking';

type PageViewTriggerProps = {
  meta: ContentTrackingMeta;
};

/**
 * Thin client adapter that fires a `content` page-view event on mount and
 * whenever the serialised `meta` identifier changes. Returns null.
 *
 * Re-renders with a value-equal `meta` do not refire — the effect is keyed on
 * the serialised meta, not the object reference. This is the soft-nav-safe
 * contract: navigating between routes with distinct meta produces one event
 * per route; React re-renders within a route do not produce duplicates.
 */
export function PageViewTrigger({ meta }: PageViewTriggerProps) {
  const metaKey = JSON.stringify(meta);

  useEffect(() => {
    logPageViewEvent(meta);
  }, [metaKey]);

  return null;
}
